import React, { useState, useEffect, useCallback } from "react";
import Header from "./Header";
import "../App.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faPhoneAlt, faCirclePlus, faTrash, faPencil, faEnvelope, faBarcode, faTransgenderAlt, faCity, faMapMarkerAlt, faBirthdayCake, faIdCard, faCalendarAlt, faBriefcase, faUniversity, faGraduationCap, faStethoscope, faCalendarCheck, faMap, faPlus, faL } from '@fortawesome/free-solid-svg-icons';
import './Profile.css';  // Import the CSS file
import { useNavigate, useLocation } from "react-router-dom"; // Use useNavigate for React Router v6+
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ClipLoader } from 'react-spinners';
import { REG_API_URL, API_URL } from "../utlis/common";


const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [fatherName, setfatherName] = useState();
  const [currentID, setcurrentID] = useState("");
  const navigate = useNavigate(); // Use useNavigate for navigation
  const [editItem, seteditItem] = useState(false);
  //UPDATE FORM
  const today = new Date().toISOString().split("T")[0];
  const [name, setname] = useState();
  const [gender, setgender] = useState();
  const [dob, setdob] = useState();
  const [phonenumber, setphonenumber] = useState();
  const [email, setemail] = useState();
  const [city, setcity] = useState();
  const [state, setstate] = useState();
  const [address, setaddress] = useState();
  const [regNumber, setregNumber] = useState();
  const [regYear, setregYear] = useState();
  const [specialization, setspecialization] = useState();
  const [employmentType, setemploymentType] = useState();
  const [uprn, setuprn] = useState();
  const [university, setuniversity] = useState();
  const [stateOfMedicine, setstateOfMedicine] = useState();
  const [qualification, setqualification] = useState();
  const [yearOfQualification, setyearOfQualification] = useState();
  const [CurrentSno, setSno] = useState();
  const [currentfilename, setcurrentfilename] = useState();
  const [imagePath, setimagePath] = useState();
  const [imageName, setimageName] = useState();
  const [galleryArray, setgalleryArray] = useState([]);
  const [image, setImage] = useState();
  const [Array, setarray] = useState({});
  const [newImsge, setnewImsge] = useState([]);
  const [Qualification, setQualification] = useState();
  const [Specializationname, setSpecializationname] = useState([]);
  const [Universityname, setUniversityname] = useState([]);
  const [Year, setYear] = useState([]); 

  //button disable 
  const [isDisabled, setIsDisabled] = useState(true); 

  const [pgQualification, setpgQualification] = useState();
  const [pgSpecializationname, setpgSpecializationname] = useState();
  const [pgUniversityname, setpgUniversityname] = useState();
  const [pgYear, setpgYear] = useState();
  const [pgArray, setpgArray] = useState([]);
  const [currentpgID, setcurrentpgID] = useState();

    //image loader
  const [profileloading, setprofileloading] = useState({});
  const [loadingImages, setLoadingImages] = useState({});

  const location = useLocation();
  const data = location.state;
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };
  const loaderStyle = {
    width: "150px",
    height: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    background: "#f0f0f0",
    fontSize: "14px",
    color: "#555",
  };
  useEffect(() => {
    const newOne = localStorage.getItem('newUser');
    const values = localStorage.getItem('currentUser') === 'undefined' ? 'null' : JSON.parse(localStorage.getItem('currentUser'));

    if ((values === '' || values === null || values === undefined) && (!newOne)) {
      navigate("/");
      return;
    }

    if (!data) {
      fetchData(values[0].RegNumber);

    }
    else {
      fetchData(data);
    }

  }, [navigate, data]);


  const fetchData = useCallback(async (ID) => {
    setLoading(true)
    try {
      const response = await axios.get(REG_API_URL);
      setarray(response.data)
      if (currentID !== "") {
        const filterValNew = response.data.filter((record) =>
          record.RegistrationNumber === currentID
        );
        if (filterValNew.length > 0) {
          setUserData(filterValNew[0]);
          const graduatPG = filterValNew && filterValNew[0].Postgraduation === "" ? [] : JSON.parse(filterValNew[0].Postgraduation)
          setpgArray(graduatPG)
          setActiveTab("personal")
        }
        else {
          setUserData([]);
        }
        setLoading(false)
      }

      else {

        const filterValOld = response.data.filter((record) =>
          record.RegistrationNumber === ID
        );
        if (filterValOld.length > 0) {
          setUserData(filterValOld[0]);
          const graduatPG = filterValOld && filterValOld[0].Postgraduation === "" ? [] :JSON.parse(filterValOld[0].Postgraduation)
          setpgArray(graduatPG)
          setcurrentfilename(filterValOld[0].image_name);
          setActiveTab("personal")
        }
        else {
          setUserData([]);
        }
        setLoading(false)
      }
      setLoading(false);
    } catch (error) {
      setLoading(false)
      toast.error("Failed to fetch registrations!");
    }
  }, [currentID]);

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "N/A"; // Return "N/A" if DOB is empty
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`; // Convert to "dd-mm-yyyy"
  };


  const handleTabChange = (tab) => {
    setActiveTab(tab); // Update activeTab state correctly
  };
  const handleFileGalleryChange = (event) => {


    if (!event.target.files || event.target.files.length === 0) {
      console.log("No files selected.");
      return;
    }

    const selectedFiles = [...event.target.files]; // Correct conversion ✅
    const newImageURLs = selectedFiles.map((file) => URL.createObjectURL(file)); // Convert to preview URLs

    setnewImsge((prev) => [...prev, ...newImageURLs]);

    console.log('fileupload')
    const selectedFilesapi = event.target.files;

    if (selectedFiles) {
      setgalleryArray([...galleryArray, ...selectedFilesapi]); // Append selected files to the array
    }
  };
  const clearPG = () => {
    setpgQualification("");
    setpgSpecializationname("");
    setpgUniversityname("");
    setpgYear("");
  }
  const handlepgInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "pgQualification") setpgQualification(value);
    else if (name === "pgUniversityname") setpgUniversityname(value);
    else if (name === "pgYear") setpgYear(value);
    else if (name === "pgSpecializationname") setpgSpecializationname(value);
  };


  const addQualification = () => {
    setLoading(true)
    if (![pgQualification, pgSpecializationname, pgUniversityname, pgYear].every(value => value !== null && value !== undefined && value !== "")) {
      setLoading(false)
      toast.error("Please fill all fields!", { position: "top-center" });
      return;
    }

    if ((pgQualification.trim() !== "" && pgSpecializationname.trim() !== "" && pgUniversityname.trim() !== "" && pgYear.trim() !== "")) {
      if (currentpgID === "" || currentpgID === undefined || currentpgID === null) {

        setTimeout(() => {
          setpgArray((prevQualifications) => [
            ...prevQualifications,
            {
              id: prevQualifications.length + 1, Qualification: pgQualification,
              Universityname: pgUniversityname,
              specializationname: pgSpecializationname,
              year: pgYear
            }
          ]);
        }, 300);
        console.log(pgArray)

        setLoading(false)

      }
      else {
        const curArray = pgArray.filter((item) => item.id === currentpgID)
        if (curArray.length > 0) {
          setTimeout(() => {
            setpgArray((prevQualifications) => {
              return prevQualifications.map((qualification) =>
                qualification.id === currentpgID
                  ? {
                    ...qualification, // Keep the existing properties of the qualification
                    ...{
                      Qualification: pgQualification,
                      Universityname: pgUniversityname,
                      specializationname: pgSpecializationname,
                      year: pgYear
                    } // Update with the new data
                  }
                  : qualification // Leave other qualifications unchanged
              );
            });
          }, 300);
          setLoading(false)

        }

      }
    }
    setLoading(false);
    setpgQualification("");
    setpgSpecializationname("");
    setpgUniversityname("");
    setpgYear("");
    setcurrentpgID("")
  };

  const editPGDeatils = (records) => {
    setcurrentpgID(records.id)
    setpgQualification(records.Qualification);
    setpgSpecializationname(records.specializationname);
    setpgUniversityname(records.Universityname);
    setpgYear(records.year);
  };

  const deletePGdetails = (items) => {
    setLoading(true)
    const delVal = pgArray.filter((itsm) => itsm.id !== items.id)
    setpgArray(delVal)
    setLoading(false)
  }

  function capitalizeFirstLetter(string) {
    return string.replace(/^\w/, c => c.toUpperCase());
  }
  const EditDetails = (data) => {
    setIsDisabled(true)
    seteditItem(true)
    setSno(data.Sno)
    setname(data.Name);
    setfatherName(data.Fathername);
    setphonenumber(data.Phonenumber);
    setdob(data.DOB);
    setgender(data.Gender);
    setemail(data.Email);
    setaddress(data.Address);
    setcity(data.City);
    setstate(data.State);
    setImage(data.image_name);
    setcurrentfilename(data.image_name);
    setqualification(data.Qualification);
    setspecialization(data.Specialization);
    setregNumber(data.RegistrationNumber);
    setregYear(data.Yearofregistration);
    setemploymentType(data.Employmenttype);
    setuprn(data.Uprnnumber);
    setuniversity(data.Universityname);
    setstateOfMedicine(data.Stateofmedicine);
    setyearOfQualification(data.Yearofqualification);
    setimagePath(data.image_path);
    setimageName(data.image_name);
    setQualification(data.Qualification);
    setUniversityname(data.Universityname);
    setSpecializationname(data.specializationname);
    setYear(data.year);
    const granval = data.Postgraduation === "" ? [] :JSON.parse(data.Postgraduation)
    setpgArray(granval)
  }
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setcurrentfilename(file.name)
    }
  };

  const SubmitFn = async () => {
    setLoading(true);
    if (!name ||
      !fatherName ||
      !dob ||
      !gender ||
      !phonenumber ||
      !email ||
      !address ||
      !qualification ||
      !specialization ||
      !regNumber ||
      !regYear ||
      !employmentType ||
      !uprn ||
      !university ||
      !stateOfMedicine ||
      !yearOfQualification ||
      image.length === 0 || // For checking empty image array
      !city ||
      !state) {
      toast.error("Please fill all fields!", { position: "top-center" });
      return;
    }

    //register number
    const valrArr = Array.filter((record) =>
      record.Sno.toLowerCase() !== CurrentSno.toLowerCase()
    );
    const checkRegNumber = valrArr.some((record) =>
      record.RegistrationNumber.toLowerCase() === regNumber.toLowerCase()
    );
    if (checkRegNumber) {
      toast.error('Given Register number is already exists'); // Show an error notification
      return;
    }

    // check upran

    const isUsernameTaken = valrArr.some((record) =>
      record.Uprnnumber.toLowerCase() === uprn.toLowerCase()
    );

    if (isUsernameTaken) {
      toast.error('Given Uprnnumber is already exists'); // Show an error notification
      return;

    }

    //phone number
    const phoneRegex = /^[0-9]{10}$/;
    if (!phonenumber) {
      return;
    }
    if (!phoneRegex.test(phonenumber)) {
      toast.error("Enter a valid 10-digit phone number.");
      return
    }
    //email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return;
    }
    if (!emailRegex.test(email)) {
      toast.error("Enter a valid email address.");
      return
    }

    let formData = new FormData();
    formData.append('Sno', capitalizeFirstLetter(CurrentSno));
    formData.append('name', capitalizeFirstLetter(name));
    formData.append('fatherName', capitalizeFirstLetter(fatherName));
    formData.append('dob', dob);
    formData.append('gender', gender);
    formData.append('phone', phonenumber);
    formData.append('email', email);
    formData.append('address', capitalizeFirstLetter(address));
    formData.append('city', capitalizeFirstLetter(city));
    formData.append('state', capitalizeFirstLetter(state));
    formData.append('qualification', capitalizeFirstLetter(qualification));
    formData.append('specialization', capitalizeFirstLetter(specialization));
    formData.append('regNumber', regNumber);
    formData.append('regYear', regYear);
    formData.append('employmentType', employmentType);
    formData.append('uprn', uprn);
    formData.append('university', capitalizeFirstLetter(university));
    formData.append('stateOfMedicine', capitalizeFirstLetter(stateOfMedicine));
    formData.append('yearOfQualification', yearOfQualification);
    formData.append('images', image)
    formData.append('image_path', imagePath);
    formData.append('postgraduate', JSON.stringify(pgArray))
    if (imageName === image) {
      formData.append('image_name', imageName);
    }
    else {
      formData.append('image_name', image.name);
    }
    galleryArray.forEach((file, index) => {
      formData.append(`galleryImages[${index}]`, file);
    });
    // console.log(formData)
    const response = await axios.post(REG_API_URL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (response.data.code === 200) {
      setLoading(false);
      toast.success(response.data.message, { position: "top-center" });
      localStorage.setItem('editItem', false);
      setIsDisabled(false)

      fetchData(regNumber)
      seteditItem(false)
      setgalleryArray([])
      setnewImsge([])


    } else {
      setLoading(false);
      toast.error("Failed to update the form!", { position: "top-center" });
    }
    setLoading(false);
  }
  const close = () => {
    seteditItem(false)
    setpgSpecializationname("")
    setpgQualification("")
    setpgUniversityname("")
    setpgYear("")
    setIsDisabled(false)
  }
  const checkPhonenumber = (phonenum) => {
    const phoneRegex = /^[0-9]{10}$/;
    if (!phonenum) {
      return;
    }
    if (!phoneRegex.test(phonenum)) {
      toast.error("Enter a valid 10-digit phone number.");
    }
  }

  const checkEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return;
    }
    if (!emailRegex.test(email)) {
      toast.error("Enter a valid email address.");
    }
  }

  const checkregnumber = (event) => {
    const value = event.target.value;
    const isUsernameTaken = Array.some((record) =>
      record.RegistrationNumber.toLowerCase() === value.toLowerCase()
    );

    if (isUsernameTaken && value.length > 0) {
      toast.error('Given Register number is already exists'); // Show an error notification

    }
    setregNumber(event.target.value);

  }
  const checkURPN = (event) => {
    const value = event.target.value;
    const isUsernameTaken = Array.some((record) =>
      record.Uprnnumber.toLowerCase() === value.toLowerCase()
    );

    if (isUsernameTaken && value.length > 0) {
      toast.error('Given Uprnnumber is already exists'); // Show an error notification

    }
    setuprn(event.target.value);

  }
  const handleImgDelete = async (imgDet) => {
    setLoading(true);
    try {
      const response = await axios.delete((REG_API_URL + '?action=deleteImage'), {
        data: { Sno: Number(CurrentSno), imageName: imgDet }, // Send the Sno for deletion
      });

      if (response.status === 200) {
        
        toast.success("Record deleted successfully!");

        const response = await axios.get(REG_API_URL);


        const filterValNew = response.data.filter((record) =>
          record.Sno === CurrentSno
        );
        if (filterValNew.length > 0) {

          setUserData(filterValNew[0]);
          setActiveTab("gallery")
        }
        else {
          setUserData([]);
        }

        setActiveTab('gallery')
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data.error || "Failed to delete record.");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error deleting record:", error);
      toast.error("Failed to delete record. Please try again.");
    }

  }
  const newhandleImgDelete = async (ind, imageURL) => {

    setnewImsge((prevImages) => {
      const indexToDelete = prevImages.indexOf(imageURL); // Find index of deleted image

      if (indexToDelete === -1) return prevImages; // If not found, return same state

      // Remove the image URL
      const updatedImages = prevImages.filter((_, index) => index !== indexToDelete);

      setgalleryArray((prevGallery) => {
        const updatedGallery = prevGallery.filter((_, index) => index !== indexToDelete);
        return updatedGallery.length > 0 ? updatedGallery : []; // Ensure empty array when last item is deleted
      });

      return updatedImages;
    });

  }
  
  const handleImageLoad = (index) => {
    setLoadingImages((prevState) => ({ ...prevState, [index]: false }));
  };

  const handleImageError = (index) => {
    setLoadingImages((prevState) => ({ ...prevState, [index]: false }));
  };

  const handleProfileImg = () => {
    setprofileloading(false);
  };

  const handleProfileError = () => {
    setprofileloading(false);
  };




  const handleDelete = () => {
    setcurrentfilename('')
    setImage('')
  }
  return (
    <div>
      {loading && (
        <div style={overlayStyle}>
          <ClipLoader size={50} color="#fff" />
        </div>
      )}
      <Header title="Profile" />
      <ToastContainer
        autoClose={500} // Auto-close in 20 seconds
        toastStyle={{ backgroundColor: "white", color: 'black', fontFamily: "'Roboto', sans-serif" }}
        progressStyle={{ background: 'white' }}
      />
      <div className="profile-container font_family_robot">
        {/* Profile Header */}
        <div>
          <div className="profile-header">
              {profileloading !== false && (
                        <div className="image-loader" style={loaderStyle}>
                          Loading...
                        </div>
                      )}
            <img
              className="profile-image"
              onLoad={() => handleProfileImg()}
              onError={() => handleProfileError()}
              src={userData.image_path ? `${API_URL}/${userData.image_path}` : 'default-image-path'}
              alt="Profile not loading"
            />
            <div className="edit_icon_pad">
              <FontAwesomeIcon icon={faPencil}
                onClick={() => EditDetails(userData)} className="cursor" />
            </div>
          </div>

        </div>

        {/* Profile Tabs */}
        <div className="tabs">
          <div className={`tab ${activeTab === "personal" ? "active" : ""}`} onClick={() => handleTabChange("personal")}>
            Personal Info
          </div>
          <div className={`tab ${activeTab === "registration" ? "active" : ""}`} onClick={() => handleTabChange("registration")}>
            Registration Details
          </div>
          <div className={`tab ${activeTab === "qualification" ? "active" : ""}`} onClick={() => handleTabChange("qualification")}>
            Qualification Info & Profile Image
          </div>
          <div className={`tab ${activeTab === "gallery" ? "active" : ""}`} onClick={() => handleTabChange("gallery")}>

            <div >
              Gallery
            </div>

          </div>

        </div>

        {/* Personal Info */}
        {activeTab === "personal" && (
          <div className="tab-content actively padding_align">

            <div className="algin_tab">
              <div className="personal-info-item tab_input_width">
                <FontAwesomeIcon icon={faUser} />
                {editItem === true &&
                  <input
                    type="text" className="txt_transform pro_input"
                    placeholder="Name"
                    value={name}
                    onChange={(e) => setname(e.target.value)}
                    maxLength={100}
                  />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>Name:</strong>
                    <div className="Profile_txt_wrap txt_transform">
                      &nbsp; {userData.Name}
                    </div>
                  </div>
                }

              </div>
              <div className="personal-info-item tab_input_width txt_transform">
                <FontAwesomeIcon icon={faUser} />
                {editItem === true &&
                  <input
                    type="text" className="txt_transform pro_input"
                    placeholder="Father name"
                    value={fatherName}
                    onChange={(e) => setfatherName(e.target.value)}
                    maxLength={100}
                  />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>Father Name:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp; {userData.Fathername}
                    </div>
                  </div>
                }

              </div>
            </div>

            <div className="algin_tab">
              <div className="personal-info-item tab_input_width">
                <FontAwesomeIcon icon={faBirthdayCake} />
                {editItem === true && <input
                  type="date"
                  className="pro_input"
                  max={today}
                  placeholder="DateOfBirth"
                  onChange={(e) => setdob(e.target.value)}
                  value={dob}
                />}
                {editItem === false &&
                  <div className="content_display">
                    <strong>Date of Birth:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp;{userData.DOB ? formatDateForDisplay(userData.DOB) : "N/A"}
                    </div>

                  </div>
                }

              </div>
              <div className="personal-info-item tab_input_width">
                <FontAwesomeIcon icon={faTransgenderAlt} />
                {editItem === true &&
                  <select className="pro_GENDER txt_trans" onChange={(e) => setgender(e.target.value)} value={gender}>
                    <option value="Select">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>

                  </select>
                }
                {editItem === false &&
                  <div className="txt_trans content_display">
                    <strong>Gender:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp;{userData.Gender}
                    </div>
                  </div>
                }

              </div>
            </div>

            <div className="algin_tab">
              <div className="personal-info-item tab_input_width">
                <FontAwesomeIcon icon={faEnvelope} />
                {editItem === true &&
                  <input type="email" placeholder="Email" className="pro_input"
                    onChange={(e) => setemail(e.target.value)}
                    onBlur={() => checkEmail(email)}
                    value={email} maxLength={50} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>Email:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp;{userData.Email}
                    </div>
                  </div>
                }
              </div>
              <div className="personal-info-item tab_input_width">
                <FontAwesomeIcon icon={faPhoneAlt} />
                {editItem === true &&

                  <input type="number" placeholder="Phone Number" className="pro_input"
                    onChange={(e) => setphonenumber(e.target.value)}
                    onBlur={() => checkPhonenumber(phonenumber)}
                    value={phonenumber} maxLength={15} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>Phone:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp; {userData.Phonenumber}
                    </div>
                  </div>
                }

              </div>
            </div>

            <div className="algin_tab">
              <div className="personal-info-item tab_input_width">
                <FontAwesomeIcon icon={faCity} />
                {editItem === true &&
                  <input type="text" placeholder="City" className="txt_transform pro_input" onChange={(e) => setcity(e.target.value)} value={city} maxLength={100} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>City:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp; {userData.City}
                    </div>
                  </div>
                }

              </div>
              <div className="personal-info-item tab_input_width">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                {editItem === true &&
                  <input type="text" placeholder="State" className="txt_transform pro_input" onChange={(e) => setstate(e.target.value)} value={state} maxLength={100} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>State:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp; {userData.State}
                    </div>
                  </div>
                }
              </div>
            </div>
            <div className="algin_tab">
              <div className="personal-info-item tab_input_width">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
                {editItem === true &&
                  <textarea placeholder="Address" rows="2" className="txt_transform pro_input" onChange={(e) => setaddress(e.target.value)} value={address} maxLength={200}></textarea>
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>Address:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp; {userData.Address}
                    </div>
                  </div>
                }

              </div>
            </div>

          </div>
        )}

        {/*Registration Info */}
        {activeTab === "registration" && (
          <div className="tab-content active">

            <div className="algin_tab">
              <div className="registration-info-item1 tab_input_width">
                <FontAwesomeIcon icon={faIdCard} className="icon_style_profile" />
                {editItem === true &&
                  <input type="text" placeholder="Registration Number"
                    className="pro_input"
                    onChange={(e) => checkregnumber(e)}
                    value={regNumber} maxLength={50} />
                }
                {editItem === false &&
                  <div className="content_display"> <strong>Registration No:</strong>

                    <div className="Profile_txt_wrap">
                      {userData.RegistrationNumber}
                    </div>
                  </div>
                }

              </div>
              <div className="registration-info-item1 tab_input_width txt_transform">
                <FontAwesomeIcon icon={faCalendarAlt} className="icon_style_profile" />
                {editItem === true &&
                  <input type="text" placeholder="Year of Registration"
                    className="pro_input" onChange={(e) => setregYear(e.target.value)} value={regYear} maxLength={50} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>Year of Registration:</strong>
                    <div className="Profile_txt_wrap">
                      {userData.Yearofregistration}
                    </div>
                  </div>
                }

              </div>
            </div>
            <div className="algin_tab">
              <div className="registration-info-item1 tab_input_width">
                <FontAwesomeIcon icon={faBriefcase} className="icon_style_profile" />
                {editItem === true &&
                  //  <div>
                  <select className="pro_GENDER" onChange={(e) => setemploymentType(e.target.value)} value={employmentType}>
                    <option value="Select">Select EmploymentType</option>
                    <option value="Self-Employed">Self-Employed</option>
                    <option value="Hospital-Employee">Hospital-Employee</option>
                    <option value="Clinic Affiliation">Clinic Affiliation</option>
                    <option value="other">Other</option>

                  </select>
                  // </div>
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>EmploymentType:</strong>
                    <div className="Profile_txt_wrap">
                      {userData.Employmenttype}
                    </div>
                  </div>
                }

              </div>
              <div className="registration-info-item1 tab_input_width txt_transform">
                <FontAwesomeIcon icon={faBarcode} className="icon_style_profile" />
                {editItem === true &&
                  <input type="text" placeholder="UPRN Number" className="txt_transform pro_input"
                    onChange={(e) => checkURPN(e)}
                    value={uprn} maxLength={50} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>UPRN Number:</strong>
                    <div className="Profile_txt_wrap">
                      {userData.Uprnnumber}
                    </div>
                  </div>
                }

              </div>
            </div>

            <div className="algin_tab">
              <div className="registration-info-item1 tab_input_width">
                <FontAwesomeIcon icon={faMap} className="icon_style_profile" />
                {editItem === true &&
                  <input type="text" placeholder="State of Medicine" className="txt_transform pro_input" onChange={(e) => setstateOfMedicine(e.target.value)} value={stateOfMedicine} maxLength={100} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>State of Medicine:</strong>
                    <div className="Profile_txt_wrap">
                      {userData.Stateofmedicine}
                    </div>
                  </div>
                }

              </div>

            </div>
            <div className="algin_tab">
              <div className="qualification-info-item1 tab_input_width">
                <div className="prfile_font">Upload image for your profile</div>
                <div className="img_style_pro">

                  <div className="img_input" >


                    <input type="file" id="file"
                      disabled={!editItem}
                      onChange={handleFileChange} accept="image/*" style={{
                        display: "none", // Hides the default file input
                      }} />

                    <div className="display_fileupload">
                      <div className="display_flex">
                        <button
                          htmlFor="file"
                          style={{
                            display: "inline-block",
                            backgroundColor: editItem ? "white" : "#ccc",
                            color: "black",
                            padding: "4Px",
                            borderRadius: "5px",
                            fontSize: "11px",
                            cursor: editItem ? "pointer" : "not-allowed",
                            border: "1px solid grey",
                            textTransform: "math-auto",
                            width: "120px",
                          }}
                          onClick={() => document.getElementById("file").click()}
                        >
                          <span> Choose File</span>
                        </button>
                        {(currentfilename !== "" && currentfilename !== undefined && editItem) &&
                          <FontAwesomeIcon style={{
                            marginRight: "8px",
                            pointerEvents: !editItem ? "none" : "auto",
                            opacity: !editItem ? 0.5 : 1,
                          }} className="view-button" title='Delete' icon={faTrash} onClick={() => handleDelete()} />}
                      </div>

                      <span className="filenamestyle">{currentfilename}</span>
                    </div>

                  </div>

                </div>

              </div>
            </div>
          </div>
        )}

        {/* Qualification Info */}
        {activeTab === "qualification" && (
          <div className="tab-content active">

            <div className="algin_tab">
              <div className="qualification-info-item1 tab_input_width">

                <FontAwesomeIcon icon={faGraduationCap} className="icon_style_profile" />
                {editItem === true &&
                  <input type="text" placeholder="Qualification" className="txt_transform pro_input" onChange={(e) => setqualification(e.target.value)} value={qualification} maxLength={100} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>Qualification:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp;{userData.Qualification}
                    </div>
                  </div>
                }

              </div>

              <div className="qualification-info-item1 tab_input_width">
                <FontAwesomeIcon icon={faCalendarCheck} className="icon_style_profile" />
                {editItem === true &&
                  <input type="text" placeholder="Year of Qualification" className="pro_input" onChange={(e) => setyearOfQualification(e.target.value)} value={yearOfQualification} maxLength={4} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>Year of Qualification:</strong>
                    <div className="Profile_txt_wrap">
                      &nbsp; {userData.Yearofqualification}
                    </div>
                  </div>
                }

              </div>
            </div>

            <div className="algin_tab">
              <div className="registration-info-item1 tab_input_width txt_transform">
                <FontAwesomeIcon icon={faUniversity} className="icon_style_profile" />
                {editItem === true &&
                  <input type="text" placeholder="University Name" className="txt_transform pro_input" onChange={(e) => setuniversity(e.target.value)} value={university} maxLength={100} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>University:</strong>
                    <div className="Profile_txt_wrap">
                      {userData.Universityname}
                    </div>
                  </div>
                }

              </div>
              <div className="registration-info-item1 tab_input_width txt_transform">
                <FontAwesomeIcon icon={faStethoscope} className="icon_style_profile" />
                {editItem === true &&
                  <input type="text" placeholder="Specialization" className="txt_transform pro_input" onChange={(e) => setspecialization(e.target.value)} value={specialization} maxLength={100} />
                }
                {editItem === false &&
                  <div className="content_display">
                    <strong>Specialization:</strong>
                    <div className="Profile_txt_wrap">
                      {userData.Specialization}
                    </div>
                  </div>

                }

              </div>
            </div>


            <div className="algin_tab">
              <div className="registration-info-item1 tab_input_width txt_transform flex_pg">
                <div className="mrg_right69"><b>Postgraduate Qualifications</b></div>
                <div className="pg_scroll_style">
                  <table className="qualification-table table MRG_TOP7">
                    <thead>
                      <tr>
                        <th className="table_colum_wrap" style={{ width: 'auto', textAlign: 'left' }}>Qualification</th>
                        <th className="table_colum_wrap">University Name</th>
                        <th className="table_colum_wrap">Specialization</th>
                        <th className="table_colum_wrap">Year</th>
                        {/* {editItem === true && */}
                          <th className="table_colum_wrap" >Action</th>
                        {/* } */}
                      </tr>
                    </thead>
                    <tbody>
                      {pgArray.length > 0 ? (
                        pgArray.map((item, index) => (
                          <tr key={index}>
                            <td className="table_colum_wrap" style={{ width: 'auto', textAlign: 'left' }}>{item.Qualification}</td>
                            <td className="table_colum_wrap">{item.Universityname}</td>
                            <td className="table_colum_wrap">{item.specializationname}</td>
                            <td className="table_colum_wrap">{item.year}</td>
                            {/* {editItem === true && */}
                              <th className="table_colum_wrap" style={{ color: '#00b4b6', backgroundColor: 'white' }}>
                              {editItem === true ? 
                                <div>
                                  <FontAwesomeIcon icon={faPencil} className="cursor" style={{ marginRight: "16px" }}
                                    onClick={() => editPGDeatils(item)} />
                                  <FontAwesomeIcon icon={faTrash} className="cursor" onClick={() => deletePGdetails(item)} />
                                </div> : 
                                <div>
                                   <FontAwesomeIcon icon={faPencil} className="cursor_notallowed" style={{ marginRight: "16px" }}  />
                                  <FontAwesomeIcon icon={faTrash} className="cursor_notallowed"  />
                                </div>
                                }

                              </th>
                            {/* } */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5">No qualifications added.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

              </div>
              {editItem === true &&
                <div className="registration-info-item1 tab_input_width txt_transform">
                  <div>
                    <input type="text" name="pgQualification" placeholder="Postgraduate" className="pro_input mrng_btm_ip" onChange={handlepgInputChange} value={pgQualification} maxLength={100} />
                    <input type="text" name="pgUniversityname" placeholder="University Name" className="pro_input" onChange={handlepgInputChange} value={pgUniversityname} maxLength={100} />
                  </div>
                  <div>
                    <input type="text" name="pgYear" placeholder="Year of Qualification" className="pro_input mrng_btm_ip" onChange={handlepgInputChange} value={pgYear} maxLength={100} />
                    <input type="text" name="pgSpecializationname" placeholder="Specialization" className="pro_input" onChange={handlepgInputChange} value={pgSpecializationname} maxLength={100} />
                  </div>
                  <div>
                    <FontAwesomeIcon className="add_icon_style cursor" icon={faPlus} onClick={addQualification} />
                    <div className="clear_progile_pg cursor" onClick={clearPG} >clear</div>
                  </div>

                </div>
              }
            </div>

          </div>
        )}
        {/* gallery */}
        {activeTab === "gallery" && (
          <div className="tab-content active">
            <div className={!userData.gallery_image_paths ? "img_align  algin_tab" : "algin_tab img_align_rt"} >
              {editItem === true && (
                <div>
                  <FontAwesomeIcon icon={faCirclePlus} className="add_icon curserPointer" onClick={() => document.getElementById("file1").click()} />
                  <input
                    type="file"
                    id="file1"
                    multiple
                    onChange={handleFileGalleryChange}
                    accept="image/*"
                    style={{
                      display: 'none',  // Hides the file input
                    }}
                  />
                </div>

              )

              }
              <div>
                {!userData.gallery_image_paths && newImsge.length === 0 &&
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", textAlign: "center" }}>
                    <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "16px", color: "red", padding: "20px" }}>No images found</div>
                  </div>}
              </div>

              <div className="img_wrap img_gap_scroll" >
                {userData.gallery_image_paths &&
                  userData.gallery_image_paths.replace(/^,/, "").split(",").map((imgPath, index) => (
                    <div  style={{ display:'flex'}}>
                      {loadingImages[index] !== false && (
                        <div className="image-loader" style={loaderStyle}>
                          Loading...
                        </div>
                      )}
                      <img
                        key={index}
                        src={`${API_URL}/${imgPath}`}
                        alt="Gallery Item"
                        width="150"
                        height="150"
                        className="img_mrg_btm"
                        onLoad={() => handleImageLoad(index)}
                        onError={() => handleImageError(index)}
                        style={{
                          borderRadius: "8px",
                          objectFit: "cover",
                          display: loadingImages[index] === false ? "block" : "none", // Hide until loaded
                        }}
                      />
                      {editItem === true &&
                        <FontAwesomeIcon className="view-button img_padding" icon={faTrash} style={{ marginRight: "8px" }} onClick={() => handleImgDelete(imgPath)} />
                      }
                    </div>


                  ))}
                {newImsge.length > 0 &&
                  newImsge.map((imgUrl, index) => (
                    <div key={index} style={{ display: "inline-block" }} className="newlt_img">
                      <img
                        src={imgUrl}
                        alt="New gallery item"
                        width="150"
                        height="150"
                        onLoad={() => setLoading(false)}
                        onError={() => setLoading(false)}
                        style={{ borderRadius: "8px", objectFit: "cover" }}
                      />
                      <FontAwesomeIcon className="view-button img_padding newImg_btom" icon={faTrash} style={{ marginRight: "8px" }} onClick={() => newhandleImgDelete(index, imgUrl)} />
                    </div>

                  ))}
              </div>
            </div>

          </div>
        )}

        {/* Close Button */}
        <div className="cls_btn_style">
          {editItem === true &&
            <button type="submit"
            className={!isDisabled ? "submit_disble_clr" : "submit-button-Profile"}
            disabled={!isDisabled}
            onClick={SubmitFn}>Submit</button>
          }
          {editItem === true &&
            <button className="close-button-Profile" onClick={close}>Close</button>
          }
        </div>


      </div>
    </div>
  );
};

export default Profile;
